export const doraDarkTheme = {
  navBackground: 'var(--bui-bg, #071c27)',
  appBackground: 'var(--bui-bg-app, #2f3645)',
  surface: 'var(--bui-bg-app, #0f2a38)',
  raisedSurface: 'var(--bui-bg-neutral-1, #424b5f)',
  hoverSurface: 'var(--bui-bg-neutral-2, #60687a)',
  border: 'var(--bui-border-1, #355566)',
  strongBorder: 'var(--bui-border-1, #525b6e)',
  primaryText: 'var(--bui-fg-primary, #d4d6dc)',
};

// border: 1px solid var(--bui-border-1, #525b6e);
//     background: var(--bui-bg-app, #2f3645);

export const doraTheme = {
  dark: doraDarkTheme,
  light: {
    surface: '#ffffff',
    appBackground: '#fafafa',
    raisedSurface: '#f7f7f9',
    hoverSurface: '#f4f4f6',
    selectedSurface: '#f0f0ff',
    progressTrack: '#f0f0f2',
    border: '#e4e4e7',
    strongBorder: '#d4d4d8',
    hoverBorder: '#c4c4c8',
    primaryText: '#111114',
    secondaryText: '#71717a',
    mutedText: '#a1a1aa',
    subtleText: '#52525b',
  },
  overlay: {
    darkPage: 'color-mix(in srgb, var(--bui-bg-app, #071c27) 0%, transparent)',
    lightPage: 'rgba(253,252,251,0.70)',
    lightCard: 'rgba(255,255,255,0.88)',
    darkBackdrop: 'rgba(0,0,0,0.6)',
    lightBackdrop: 'rgba(0,0,0,0.3)',
    darkControl: 'rgba(255,255,255,0.06)',
    darkControlHover: 'rgba(255,255,255,0.12)',
    lightControl: 'rgba(0,0,0,0.06)',
    lightControlHover: 'rgba(0,0,0,0.1)',
  },
  shadow: {
    darkCard: '0 0 0 1px rgba(250,100,0,0.06), 0 32px 80px rgba(0,0,0,0.65)',
    lightCard: '0 32px 80px rgba(0,0,0,0.12)',
    darkHover: '0 8px 24px rgba(0,0,0,0.4)',
    lightHover: '0 8px 24px rgba(0,0,0,0.08)',
    darkPopover: '0 4px 24px rgba(0,0,0,0.4)',
    lightPopover: '0 4px 24px rgba(0,0,0,0.12)',
    darkTooltip: '0 6px 20px rgba(0,0,0,0.55)',
    lightTooltip: '0 6px 20px rgba(0,0,0,0.10)',
    darkOverlay: '0 24px 64px rgba(0,0,0,0.7)',
    lightOverlay: '0 24px 64px rgba(0,0,0,0.18)',
  },
  dora: {
    orange: '#FA6400',
    orangeStroke: '#C24E00',
    orangeShadow: '#902800',
    orangeDeepShadow: '#5A1800',
    darkWordmarkShadow:
      '3px 3px 0 #C24E00, 6px 6px 0 #902800, 9px 9px 0 #5A1800, 12px 12px 0 rgba(0,0,0,0.55), 0 0 60px rgba(250,100,0,0.45)',
    lightWordmarkShadow:
      '3px 3px 0 #C24E00, 6px 6px 0 #902800, 9px 9px 0 rgba(80,20,0,0.28), 0 0 32px rgba(250,100,0,0.22)',
    pulseBorder: 'rgba(250,100,0,0.5)',
    activeGlow: '0 0 14px rgba(250,100,0,0.7)',
    darkAmbientGlow: 'rgba(250,100,0,0.08)',
    lightAmbientGlow: 'rgba(250,100,0,0.05)',
  },
  chart: {
    darkMutedBorder: 'rgba(255,255,255,0.06)',
    lightMutedBorder: 'rgba(0,0,0,0.06)',
    darkGrid: 'rgba(255,255,255,0.05)',
    lightGrid: 'rgba(0,0,0,0.05)',
  },
  metric: {
    deployment: '#FA6400',
    leadTime: '#818cf8',
    failure: '#f87171',
    restore: '#fbbf24',
    good: '#4ade80',
    warning: '#fb923c',
    lime: '#a3e635',
    goodDeltaDark: 'rgba(74,222,128,0.08)',
    goodDeltaLight: 'rgba(74,222,128,0.12)',
    badDeltaDark: 'rgba(248,113,113,0.08)',
    badDeltaLight: 'rgba(248,113,113,0.12)',
  },
  rating: {
    elite: { background: '#14532d', color: '#86efac', border: '#166534' },
    high: { background: '#1e3a5f', color: '#93c5fd', border: '#1d4ed8' },
    medium: { background: '#451a03', color: '#fdba74', border: '#92400e' },
    low: { background: '#450a0a', color: '#fca5a5', border: '#991b1b' },
  },
};

export const doraDurationGradient = [
  doraTheme.metric.failure,
  doraTheme.metric.warning,
  doraTheme.metric.restore,
  doraTheme.metric.lime,
  doraTheme.metric.good,
];
